import script from "./MineralsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./MineralsHome.vue?vue&type=script&setup=true&lang=js"

import "./MineralsHome.vue?vue&type=style&index=0&id=2c065ba2&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c065ba2"]])

export default __exports__